import React from 'react';
import Navbar from '../components/Navbar';
import PricingList from '../components/PricingList';
import Footer from '../components/Footer';

const PricingPage = () => {
  return (
    <div className="min-h-screen bg-black text-white font-sans selection:bg-yellow-500 selection:text-black">
      <Navbar />
      <PricingList />
      <Footer />
    </div>
  );
};

export default PricingPage;
